module.exports = __webpack_public_path__ + "img/news_header.956201af.jpg";